const NOTIFY_TEXT = /notify\s+me(?:\s+when\s+available)?|back\s+in\s+stock/i;
const SOLD_OUT_TEXT = /sold\s+out|unavailable/i;

function visibleNotifyAction(root) {
  return Array.from(root.querySelectorAll('button, a, [role="button"]')).find((element) => {
    if (!(element instanceof HTMLElement)) return false;
    if (element.classList.contains('hc-back-in-stock-trigger')) return false;
    return NOTIFY_TEXT.test(element.textContent?.trim() || '');
  });
}

function purchaseButton(root) {
  return Array.from(
    root.querySelectorAll('product-form-component button, .product-form-buttons button, button[name="add"]'),
  ).find((element) => {
    if (!(element instanceof HTMLButtonElement)) return false;
    return element.classList.contains('hc-back-in-stock-trigger') || SOLD_OUT_TEXT.test(element.textContent?.trim() || '');
  });
}

function restorePurchaseButton(button) {
  if (!button.classList.contains('hc-back-in-stock-trigger')) return;

  const originalLabel = button.dataset.hcOriginalLabel;
  if (originalLabel) button.textContent = originalLabel;
  button.disabled = true;
  button.setAttribute('aria-disabled', 'true');
  button.classList.remove('hc-back-in-stock-trigger');
  delete button.dataset.hcNotifyTarget;
}

function syncBackInStockAction() {
  const root = document.querySelector('main');
  if (!root) return;

  const button = purchaseButton(root);
  if (!button) return;

  const notifyAction = visibleNotifyAction(root);
  if (!notifyAction) {
    restorePurchaseButton(button);
    return;
  }

  if (!notifyAction.id) {
    notifyAction.id = `hc-back-in-stock-${Math.random().toString(36).slice(2, 9)}`;
  }

  if (!button.dataset.hcOriginalLabel) {
    button.dataset.hcOriginalLabel = button.textContent?.trim() || 'Sold out';
  }

  const notifyLabel = notifyAction.textContent?.trim() || 'Notify me when available';
  if (
    button.classList.contains('hc-back-in-stock-trigger') &&
    button.dataset.hcNotifyTarget === notifyAction.id &&
    button.textContent?.trim() === notifyLabel
  ) {
    return;
  }

  button.textContent = notifyLabel;
  button.type = 'button';
  button.disabled = false;
  button.removeAttribute('aria-disabled');
  button.classList.add('hc-back-in-stock-trigger');
  button.dataset.hcNotifyTarget = notifyAction.id;
  notifyAction.classList.add('hc-back-in-stock-source');
}

document.addEventListener('click', (event) => {
  const trigger = event.target instanceof Element
    ? event.target.closest('.hc-back-in-stock-trigger')
    : null;
  if (!(trigger instanceof HTMLButtonElement)) return;

  event.preventDefault();
  const targetId = trigger.dataset.hcNotifyTarget;
  const notifyAction = targetId ? document.getElementById(targetId) : null;
  notifyAction?.click();
});

let queued = false;
function queueSync() {
  if (queued) return;
  queued = true;
  window.requestAnimationFrame(() => {
    queued = false;
    syncBackInStockAction();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', queueSync, { once: true });
} else {
  queueSync();
}

const productRoot = document.querySelector('main');
if (productRoot) {
  new MutationObserver(queueSync).observe(productRoot, { childList: true, subtree: true });
}

document.addEventListener('shopify:section:load', queueSync);
